// extracted by mini-css-extract-plugin
export default {"card":"Card__card___zgZxz","link":"Card__link___xwiK1","description":"Card__description___QBarY"};